"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("../AnalyticsProvider");
//  Map vehicleType enums to vehicleStatus required by Shift Digital as per the Shift implementation guide.
var vehicleStatusMap = {
    New: "New",
    Used: "Used",
    "Certified Used": "CPO",
};
var dealTypeMap = {
    loan: "Finance",
    lease: "Lease",
    cash: "Cash",
};
/**
 * For the lack of a better location to document tribal knowledge...
 * Shift changelog
 * 04/2021 - ONSHOP-6504 Shift notices that if you don't interact with inputs on payment builder,
 *      you get neither drPaymentCalcStart nor drPaymentCalcFinish
 *      Concurrent work on ONSHOP-6491 means all Electric deals go through Payment calc, so we decided to simplify
 *      drPaymentCalcStart is sent to Shift when Electric fires paymentBuilderLoad, or Redline fires paymentOptionsLoad
 *      https://dealerinspire.slack.com/archives/G89LE4XM3/p1619039764048500
 *
 *      Shift also announced that a major v2.0 change is coming soon.
 *      The current plan is to *completely rewrite* this provider when the 2.0 spec is available with a stricter emphasis on:
 *      - public FEA methods do not call each other. If several FEA events cause one vendor action,
 *          use private methods like drPaymentCalcStart()
 *      - virtualPageView should not be used to fire discrete events, if you need to act on  "when the customer sees X"
 *          introduce new events like paymentBuilderLoad()
 *
 * 12/2020 - GMCA Shift requested the following changes:
 * 1) Only fire these events once per dealId (session), including leadFormStart, hardPullCreditAppComplete, FAndIFinish.
 * 2) Send in VehicleStatus as a new prop per v1.1 Shift implementation guide.
 * Shift confirmed internally with Ryan Ruiz to keep previous changes as they are.
 * They also confirmed that this can be applied across all OEMs.
 */
var ShiftDigitalProvider = /** @class */ (function (_super) {
    __extends(ShiftDigitalProvider, _super);
    function ShiftDigitalProvider(engineConfig, sdConfig) {
        var _this = _super.call(this, "sd", engineConfig.isLockedPricing) || this;
        _this.loaded = false;
        /**
         * Helper function - Returns object shape required for Shift Digital, maps vehicleType enums
         * to the ones mentioned in Appendix 1 of the Shift implementation guide.
         *
         * Returns a new object where vehicleStatus is mapped to vehicleType and removes vehicleTrim property.
         */
        _this.getShiftDigitalEventObject = function (dealId, vehicle) {
            var _a, _b, _c, _d, _e;
            return {
                dealId: dealId,
                dealType: dealTypeMap[(_e = (_c = (_b = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _a === void 0 ? void 0 : _a.dealer) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _d === void 0 ? void 0 : _d.selected) !== null && _e !== void 0 ? _e : "loan"],
                priceUnlocked: _this.unlockedPricing ? "True" : "False",
                provider: "DealerInspire",
                vehicleMake: vehicle.make,
                vehicleModel: vehicle.model,
                vehicleStatus: vehicleStatusMap[vehicle.type],
                vehicleVin: vehicle.vin,
                vehicleYear: vehicle.year,
            };
        };
        _this.engineConfig = engineConfig;
        _this.sdConfig = sdConfig;
        _this.prepareLocalSD();
        // Push config onto the temp queue (q), has to be before any further events (e.g. initialClick)
        _this.sd("create", (_this.sdConfig.oem || "").toUpperCase(), _this.sdConfig.retailerId, _this.sdConfig.providerId);
        _this.loadSD();
        return _this;
    }
    // Set up a basic queue, in synchronous-time, that events go into.
    // When Shift finally loads in all their dependencies, they drain the queue
    ShiftDigitalProvider.prototype.prepareLocalSD = function () {
        // @ts-ignore
        window.sd =
            // @ts-ignore
            window.sd ||
                function () {
                    // @ts-ignore
                    (window.sd.q = window.sd.q || []).push(arguments);
                };
        // @ts-ignore
        window.sd.l = 1 * new Date();
    };
    /**
     * TypeScript hates calling methods ShiftDigital hot-patched onto window.
     * Lets centralize all that angst in here.
     */
    ShiftDigitalProvider.prototype.sd = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-ignore
        window.sd.apply(window, __spread(arguments));
    };
    /**
     * Override the Shift object (typically attached to window and private scope by loadSD)
     * especially for mocking in unit tests.
     * @param sd    Typically a Jest Mock Function
     */
    ShiftDigitalProvider.prototype.injectSd = function (sd) {
        this.sd = sd;
    };
    /**
     * Add a <script> element to the page that starts the (laborious) process of
     * loading Shift's whole library, eventually replacing window.sd and draining window.sd.q
     */
    ShiftDigitalProvider.prototype.loadSD = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.loaded) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (function (i, s, o, g, r, a, m) {
                                i["ShiftAnalyticsObject"] = r;
                                // @ts-ignore
                                (a = s.createElement(o)),
                                    // @ts-ignore
                                    (m = s.getElementsByTagName(o)[0]);
                                // @ts-ignore
                                a.async = 1;
                                // @ts-ignore
                                a.src = g;
                                // @ts-ignore
                                m.parentNode.insertBefore(a, m);
                            })(window, document, "script", this.sdConfig.url, "sd")];
                    case 2:
                        _a.sent();
                        this.loaded = true;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log("Unable to load Shift Digital library with error: ", e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShiftDigitalProvider.prototype.opened = function (dealId, vehicle) {
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drImpression",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.closed = function (dealId, vehicle) {
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drDropSave",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.dealCreated = function (dealId, vehicle) {
        if (this.engineConfig.isRedline) {
            this.sd("dataLayer", {
                digRet: this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drInitialClick",
                pageType: "Digital Retailing",
            });
            this.sd("send", "pageview");
            return;
        }
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drInitialClick",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.vehicleRemoved = function (dealId, vehicle) {
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drDropSave",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.leadFormViewed = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("leadFormViewed", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drLeadFormShown",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.leadFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("leadFormStarted", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drLeadFormStart",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.leadFormFinished = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("leadFormFinished", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drLeadFormFinish",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.softCreditFormViewed = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("softCreditFormViewed", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drPreQShown",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.softCreditFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("softCreditFormStarted", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drPreQStart",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.softCreditFormFinished = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("softCreditFormFinished", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drPreQFinish",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.paymentCalcViewed = function (dealId, vehicle) {
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drPaymentCalcShown",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.paymentCalcInteraction = function (dealId, vehicle) {
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drPaymentCalcInteraction",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.paymentCalcFinished = function (dealId, vehicle) {
        this.sd("dataLayer", {
            digRet: this.getShiftDigitalEventObject(dealId, vehicle),
            events: "drPaymentCalcFinish",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.schedulePickupOrDeliveryFormViewed = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("schedulePickupOrDeliveryFormViewed", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drApptSchedShown",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.schedulePickupOrDeliveryFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("schedulePickupOrDeliveryFormStarted", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drApptSchedStart",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.schedulePickupOrDeliveryFormFinished = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("schedulePickupOrDeliveryFormFinished", function () {
            var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);
            _this.sd("dataLayer", {
                digRet: shiftDigitalObject,
                events: "drApptSched",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.tradeInFormViewed = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerVehicle("tradeInFormViewed", vehicle, function () {
            _this.sd("dataLayer", {
                digRet: _this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drTradeInShown",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.tradeInFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerVehicle("tradeInFormStarted", vehicle, function () {
            _this.sd("dataLayer", {
                digRet: _this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drTradeInStart",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.tradeInFormFinished = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerVehicle("tradeInFormFinished", vehicle, function () {
            _this.sd("dataLayer", {
                digRet: _this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drTradeInFinish",
            });
            _this.sd("send");
        });
    };
    /**
     * Hard Credit Pull
     */
    ShiftDigitalProvider.prototype.hardCreditFormViewed = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("hardCreditFormViewed", function () {
            _this.sd("dataLayer", {
                digRet: _this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drCreditAppShown",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.hardCreditFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("hardCreditFormStarted", function () {
            _this.sd("dataLayer", {
                digRet: _this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drCreditAppStart",
            });
            _this.sd("send");
        });
    };
    ShiftDigitalProvider.prototype.hardCreditFormFinished = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("hardCreditFormFinished", function () {
            _this.sd("dataLayer", {
                digRet: _this.getShiftDigitalEventObject(dealId, vehicle),
                events: "drCreditAppFinish",
            });
            _this.sd("send");
        });
    };
    /**
     * Though reserving a vehicle is a technically separate event,
     * Shift requests we submit the leadFormShown/Start/Finish events.
     *
     * NOTE: This *appears* to fire leadFormView leadFormStart and leadFormFinish, but in *practice*
     * each of those events only fires once per session, and you have to go past the login form to get to the reservation form,
     * so in *practice* Shift never sees events about the reserve form
     */
    ShiftDigitalProvider.prototype.reserveVehicleFormViewed = function (dealId, vehicle) {
        this.leadFormViewed(dealId, vehicle);
    };
    ShiftDigitalProvider.prototype.reserveVehicleFormStarted = function (dealId, vehicle) {
        this.leadFormStarted(dealId, vehicle);
    };
    ShiftDigitalProvider.prototype.reserveVehicleFormFinished = function (dealId, vehicle) {
        this.leadFormFinished(dealId, vehicle);
    };
    ShiftDigitalProvider.prototype.upgradesViewed = function (dealId, vehicle) {
        var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
        // We will be separating Upgrades into FI & Accessories in the future
        // this.sd("dataLayer", {
        //     digRet: shiftDigitalObject,
        //     events: "drFiShown",
        // });
        // this.sd("send");
        this.sd("dataLayer", {
            digRet: shiftDigitalObject,
            events: "drAccessoriesShown",
        });
        this.sd("send");
    };
    ShiftDigitalProvider.prototype.upgradeAdded = function (id, dealId, vehicle, addOnType, addOnName) {
        var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
        shiftDigitalObject.addOnType = "Accessories";
        shiftDigitalObject.addOnName = addOnName;
        this.sd("dataLayer", {
            digRet: shiftDigitalObject,
            events: "drAddToCart",
        });
        this.sd("send");
    };
    /**
     * For now we send both `drFiFinish` and `drAccessoriesFinish` events since
     * we don't separate between physical and non-physical add-ons
     */
    ShiftDigitalProvider.prototype.upgradesFinished = function (dealId, vehicle) {
        var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
        // this.sd("dataLayer", {
        //     digRet: shiftDigitalObject,
        //     events: "drFiFinish",
        // });
        // this.sd("send");
        this.sd("dataLayer", {
            digRet: shiftDigitalObject,
            events: "drAccessoriesFinish",
        });
        this.sd("send");
    };
    /**
     * Should be called when the customer first sees the Test Drive form
     *
     * @param  dealId
     * @param  vehicle
     */
    ShiftDigitalProvider.prototype.testDriveFormViewed = function (dealId, vehicle) {
        var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
        this.sd("dataLayer", {
            digRet: shiftDigitalObject,
            events: "drApptSchedShown",
        });
        this.sd("send");
    };
    /**
     * Should be called when the customer begins to interact with the Test Drive form/calendar
     *
     * @param  dealId
     * @param  vehicle
     */
    ShiftDigitalProvider.prototype.testDriveFormStarted = function (dealId, vehicle) {
        var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
        this.sd("dataLayer", {
            digRet: shiftDigitalObject,
            events: "drApptSchedStart",
        });
        this.sd("send");
    };
    /**
     * Should be called when the customer completes scheduling test drive appointment
     *
     * @param  dealId
     * @param  vehicle
     */
    ShiftDigitalProvider.prototype.testDriveFormFinished = function (dealId, vehicle) {
        var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
        this.sd("dataLayer", {
            digRet: shiftDigitalObject,
            events: "drApptSchedFinish",
        });
        this.sd("send");
    };
    return ShiftDigitalProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = ShiftDigitalProvider;
